(function () {
  'use strict';

  /* Guard: scripts.liquid loads this globally as type="module"; sections also
     load it with defer. Without this guard, event listeners register twice,
     causing double cart-add on every click. */
  if (window.__tovProductCardInit) return;
  window.__tovProductCardInit = true;

  /* ── Variation overlay ── */
  function openOverlay(productId) {
    var overlay = document.getElementById('var-overlay-' + productId);
    if (overlay) overlay.classList.add('open');
  }

  function closeOverlay(productId) {
    var overlay = document.getElementById('var-overlay-' + productId);
    if (overlay) overlay.classList.remove('open');
  }

  /* ── Update overlay price when variant changes ── */
  function handleVariantChange(select) {
    var productId = select.dataset.productId;
    var priceEl   = document.getElementById('overlay-price-' + productId);
    var addBtn    = document.querySelector('[data-overlay-add="' + productId + '"]');
    var option    = select.options[select.selectedIndex];

    if (priceEl) priceEl.textContent     = option.dataset.price;
    if (addBtn)  addBtn.dataset.variantId = select.value;
  }

  /* ── Ajax: add to cart + open side cart ── */
  /* Delegates to the single shared window.tovAddToCart defined in tov-header.js */
  function addToCart(variantId, btn) {
    window.tovAddToCart(variantId, 1, btn);
  }

  /* ── Event delegation ── */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var openBtn = t.closest('[data-open-overlay]');
    if (openBtn) { openOverlay(openBtn.dataset.openOverlay); return; }

    var closeBtn = t.closest('[data-close-overlay]');
    if (closeBtn) { closeOverlay(closeBtn.dataset.closeOverlay); return; }

    var clearBtn = t.closest('[data-clear-overlay]');
    if (clearBtn) {
      var pid = clearBtn.dataset.clearOverlay;
      var sel = document.querySelector('.overlay-variant-select[data-product-id="' + pid + '"]');
      if (sel) { sel.selectedIndex = 0; handleVariantChange(sel); }
      return;
    }

    var singleAddBtn = t.closest('[data-add-to-cart]');
    if (singleAddBtn) { e.preventDefault(); addToCart(singleAddBtn.dataset.addToCart, singleAddBtn); return; }

    var overlayAddBtn = t.closest('[data-overlay-add]');
    if (overlayAddBtn) {
      e.preventDefault();
      var vid = overlayAddBtn.dataset.variantId;
      if (vid) { addToCart(vid, overlayAddBtn); closeOverlay(overlayAddBtn.dataset.overlayAdd); }
      return;
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.classList.contains('overlay-variant-select')) handleVariantChange(e.target);
  });

})();
